export const AI_CONTROLLER_PARAM = 'drive-with-ai';
export const STORAGE_OPEN_AI_API_KEY = 'openAiApiKey';
export const STORAGE_SYSTEM_PROMPT = 'systemPrompt';
export const DRIVE_MODE = {
	human: 'human',
	ai: 'ai'
};
export const ENABLED_DRIVE_MODES = {
	...DRIVE_MODE,
	both: 'both'
};
